<div class="sidenav-content filter-menu">

  <div class="card mat-white-bg">
    <!-- SIDENAV HEADER -->
    <div class="header p-24" fxLayout="row" fxLayoutAlign="start center" >

      <!-- USER -->
      @if (!activeFilters) {
        <mat-icon>filter_list</mat-icon>
      }
      @if (activeFilters) {
        <mat-icon>check_circle_outline</mat-icon>
      }
      <span [ngStyle]="{color: activeFilters ? 'gray' : 'black'}" class="title">{{'main.filters' | translate}}</span>
      <!-- / USER -->

    </div>
    <!-- / SIDENAV HEADER -->

    <!-- SIDENAV CONTENT -->
    <div class="content">

      <div class="nav">

        @if (page !== 'budget') {
          <div class="nav-item bottom-border" aria-label="inbox" (click)="choose('all')">
            <a class="nav-link" matRipple>
              <span class="title all-data">{{'main.all_' + page | translate}}</span>
            </a>
          </div>
        }

        @if (filters.countries) {
          <div class="nav-item bottom-border" aria-label="frequently contacted">
            <div class="filter-title" (click)="showCountry = !showCountry">
              {{'organization.country' | translate}}
              @if (showCountry) {
                <mat-icon  class="expand-icon">expand_less</mat-icon>
              }
              @if (!showCountry) {
                <mat-icon  class="expand-icon">expand_more</mat-icon>
              }
            </div>
            <mat-radio-group class="radio-group" #country [ngClass]="{'visible': showCountry, 'hidden': !showCountry}">
              @for (country of filters.countries; track country.id) {
                <mat-radio-button class="radio-buttons" (change)="choose({country: country.id})"
                  [value]="country.code"
                  [checked]="(+country.id === +countryIdRoute) || country?.selected">
                  {{country?.name}}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        }

        @if (filters.cantons) {
          <div class="nav-item bottom-border" aria-label="frequently contacted">
            <div class="filter-title" (click)="showCanton = !showCanton">
              <div>{{'main.canton' | translate}}</div>
              @if (showCanton) {
                <mat-icon  class="expand-icon">expand_less</mat-icon>
              }
              @if (!showCanton) {
                <mat-icon  class="expand-icon">expand_more</mat-icon>
              }
            </div>
            <mat-selection-list   [ngClass]="{'visible': showCanton, 'hidden': !showCanton}" (selectionChange)="chooseCanton($event)">
              @for (cantone of filters.cantons; track cantone.id) {
                <mat-list-option class="target-list"
                  [value]="cantone.id" (click)="cantone.selected = !cantone.selected"
                  matTooltip="{{cantone?.name}}" [selected]="cantone.selected">
                  {{cantone?.name}}
                </mat-list-option>
              }
            </mat-selection-list>
          </div>
        }

        @if (filters.cantonFB) {
          <div class="nav-item bottom-border" aria-label="frequently contacted">
            <div class="filter-title" (click)="showCantonFB = !showCantonFB">
              <div>{{'main.canton' | translate}}</div>
              @if (showCantonFB) {
                <mat-icon  class="expand-icon">expand_less</mat-icon>
              }
              @if (!showCantonFB) {
                <mat-icon  class="expand-icon">expand_more</mat-icon>
              }
            </div>
            <mat-radio-group class="radio-group" #cantonsFB [ngClass]="{'visible': showCantonFB, 'hidden': !showCantonFB}">
              @for (canton of filters.cantonFB; track canton.id) {
                <mat-radio-button class="radio-buttons" (change)="choose({cantonFB: canton.id})"
                  matTooltip="{{canton?.name}}"
                  [value]="canton.id"
                  [checked]="canton?.selected">
                  {{canton?.name}}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        }


        @if (filters.organizations) {
          <div class="nav-item bottom-border" aria-label="frequently contacted">
            <div class="filter-title" (click)="showOrganization = !showOrganization">
              {{'user.organization' | translate}}
              @if (showOrganization) {
                <mat-icon  class="expand-icon">expand_less</mat-icon>
              }
              @if (!showOrganization) {
                <mat-icon  class="expand-icon">expand_more</mat-icon>
              }
            </div>
            <mat-selection-list [ngClass]="{'visible': showOrganization, 'hidden': !showOrganization}"
              (selectionChange)="chooseOrg($event)">
              @for (org of filters.organizations; track org.id) {
                <mat-list-option class="target-list"
                  matTooltip="{{org?.name}}"
                  (click)="org.selected = !org.selected;" [value]="org.id"
                  [selected]="org.selected">
                  {{org?.name}}
                </mat-list-option>
              }
            </mat-selection-list>
          </div>
        }

        @if (filters.organizationsFB) {
          <div class="nav-item bottom-border" aria-label="frequently contacted">
            <div class="filter-title" (click)="showOrganizationFB = !showOrganizationFB">
              {{'user.organization' | translate}}
              @if (showOrganizationFB) {
                <mat-icon  class="expand-icon">expand_less</mat-icon>
              }
              @if (!showOrganizationFB) {
                <mat-icon  class="expand-icon">expand_more</mat-icon>
              }
            </div>
            <!--<mat-selection-list [ngClass]="{'visible': showOrganization, 'hidden': !showOrganization}">-->
            <!--<mat-list-option class="target-list" *ngFor="let org of filters.organizations"-->
            <!--matTooltip="{{org?.name}}"-->
            <!--(click)="org.selected = !org.selected;choose({organization: org.id, selected: org.selected})"-->
            <!--[selected]="org.selected">-->
            <!--{{org?.name}}-->
          <!--</mat-list-option>-->
        <!--</mat-selection-list>-->
        <mat-radio-group class="radio-group" #organizationsFB [ngClass]="{'visible': showOrganizationFB, 'hidden': !showOrganizationFB}">
          @for (org of filters.organizationsFB; track org.id) {
            <mat-radio-button class="radio-buttons" (change)="choose({organizationsFB: org.id})"
              matTooltip="{{org?.name}}"
              [value]="org.id"
              [checked]="org?.selected">
              {{org?.name}}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }

    @if (filters.tags) {
      <div class="nav-item bottom-border" aria-label="frequently contacted">
        <div class="filter-title" (click)="showTag = !showTag">
          {{'main.tag' | translate}}
          @if (showTag) {
            <mat-icon  class="expand-icon">expand_less</mat-icon>
          }
          @if (!showTag) {
            <mat-icon  class="expand-icon">expand_more</mat-icon>
          }
        </div>
        <mat-selection-list [ngClass]="{'visible': showTag, 'hidden': !showTag}"
          (selectionChange)="chooseTags($event)">
          @for (tag of filters.tags; track tag) {
            <mat-list-option class="target-list"
              matTooltip="{{tag?.name}}"
              (click)="tag.selected = !tag.selected" [value]="tag.id"
              [selected]="tag.selected">
              {{tag?.name}}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    }

        @if (filters.platforms) {
          <div class="nav-item bottom-border" aria-label="frequently contacted">
            <div class="filter-title">{{'main.platforms' | translate}}
              <span class="clean" (click)="choose({platforms: ''}); platformsModel = ''">{{'clean' | translate}}</span>
            </div>
            <mat-radio-group class="radio-group" #platforms [(ngModel)]="platformsModel">
              @for (plt of filters.platforms; track plt.id) {
                <mat-radio-button class="radio-buttons" (change)="choose({platforms: plt.id})"
                                  matTooltip="{{plt?.title}}"
                                  [value]="plt.id"
                                  [checked]="plt?.selected">
                  {{plt?.title}}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        }

    @if (filters.blogTypes) {
      <div class="nav-item bottom-border" aria-label="frequently contacted">
        <div class="filter-title" (click)="showTag = !showTag">
          {{'main.blogType' | translate}}
          @if (showTag) {
            <mat-icon  class="expand-icon">expand_less</mat-icon>
          }
          @if (!showTag) {
            <mat-icon  class="expand-icon">expand_more</mat-icon>
          }
        </div>
        <mat-selection-list [ngClass]="{'visible': showTag, 'hidden': !showTag}">
          @for (bt of filters.blogTypes; track bt) {
            <mat-list-option class="target-list"
              matTooltip="{{bt?.name}}"
              (click)="bt.selected = !bt.selected;choose({tag: bt.id, selected: bt.selected})"
              [selected]="bt.selected">
              {{bt?.name}}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    }

    @if (filters.blobVisibility) {
      <div class="nav-item bottom-border" aria-label="frequently contacted">
        <div class="filter-title">{{'blog.blogs_visibility' | translate}}</div>
        <mat-radio-group class="radio-group" [value]="publicBlogsModel">
          <mat-radio-button class="radio-buttons" (change)="choose({publicBlogs: 'public'})"
            [value]="'public'">
            {{'event.public' | translate}}
          </mat-radio-button>
          <mat-radio-button class="radio-buttons" (change)="choose({publicBlogs: 'internal'})"
            [value]="'internal'">
            {{'event.internal' | translate}}
          </mat-radio-button>
          <mat-radio-button class="radio-buttons" (change)="choose({publicEvents: ''})"
            [value]="'any'">
            {{'event.any' | translate}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    }


    @if (filters.roles) {
      <div class="nav-item bottom-border" aria-label="frequently contacted">
        <div class="filter-title" (click)="showRole = !showRole">
          {{'user.role' | translate}}
          @if (showRole) {
            <mat-icon  class="expand-icon">expand_less</mat-icon>
          }
          @if (!showRole) {
            <mat-icon  class="expand-icon">expand_more</mat-icon>
          }
        </div>
        <mat-selection-list [ngClass]="{'visible': showRole, 'hidden': !showRole}" (selectionChange)="chooseRole($event)">
          @for (role of filters.roles; track role.id) {
            <mat-list-option matTooltip="{{('main._' + role?.name) | translate }}"
              (click)="role.selected = !role.selected;" [value]="role.id"
              class="target-list" [selected]="(orgIdRoute && +role.id === 4) || role.selected">
              {{('main._' + role?.name) | translate }}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    }

    @if (filters.activated) {
      <div class="nav-item bottom-border pl-16 alone" aria-label="frequently contacted">
        <div class="title">{{'user.activated' | translate}}</div>
        <mat-checkbox [checked]="activatedModel"
          (change)="choose({activated: $event.checked})" style="float: right"
          [labelPosition]="'before'">
        </mat-checkbox>
      </div>
    }
    @if (filters.recommendator) {
      <div class="nav-item bottom-border pl-16 alone" aria-label="frequently contacted">
        <div class="title" matTooltip="{{'user.recommendator' | translate}}">{{'user.recommendator' | translate}}</div>
        <mat-checkbox [checked]="recommendatorModel"
          (change)="choose({recommendator: $event.checked})" style="float: right"
          [labelPosition]="'before'">
        </mat-checkbox>
      </div>
    }
    @if (filters.noActivated) {
      <div class="nav-item bottom-border pl-16 alone" aria-label="frequently contacted">
        <div class="title">{{'user.noActivated' | translate}}</div>
        <mat-checkbox [checked]="noActivatedModel"
          (change)="choose({noActivated: $event.checked})" style="float: right"
          [labelPosition]="'before'">
        </mat-checkbox>
      </div>
    }
  </div>

  @if (filters.eventRegistration) {
    <div class="nav-item bottom-border pl-16 alone" aria-label="frequently contacted">
      <div class="title target-list" matTooltip="{{'event.event_registration' | translate}}">
      {{'event.event_registration' | translate}}</div>
      <mat-checkbox [checked]="eventRegistrationModel"
        (change)="choose({eventRegistration: true, selected: $event.checked})"
        [labelPosition]="'before'">
      </mat-checkbox>
    </div>
  }

  @if (filters.publicEvents) {
    <div class="nav-item bottom-border" aria-label="frequently contacted">
      <div class="filter-title">{{'event.events_visibility' | translate}}</div>
      <mat-radio-group class="radio-group" [value]="publicEventsModel">
        <mat-radio-button class="radio-buttons" (change)="choose({publicEvents: 'public'})"
          [value]="'public'">
          {{'event.public' | translate}}
        </mat-radio-button>
        <mat-radio-button class="radio-buttons" (change)="choose({publicEvents: 'internal'})"
          [value]="'internal'">
          {{'event.internal' | translate}}
        </mat-radio-button>
        <mat-radio-button class="radio-buttons" (change)="choose({publicEvents: ''})"
          [value]="'any'">
          {{'event.any' | translate}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  }

      @if (filters.learningPathsVisibility) {
        <div class="nav-item bottom-border" aria-label="frequently contacted">
          <div class="filter-title">{{'learning_paths.visibility' | translate}}
            <span class="clean" (click)="choose({learningPathsVisibility: ''}); learningPathsVisibilityModel = ''">{{'clean' | translate}}</span>
          </div>
          <mat-radio-group class="radio-group" [value]="learningPathsVisibilityModel">
            <mat-radio-button class="radio-buttons" (change)="choose({learningPathsVisibility: 'public'})"
                              [value]="'public'">
              {{'event.public' | translate}}
            </mat-radio-button>
            <mat-radio-button class="radio-buttons" (change)="choose({learningPathsVisibility: 'internal'})"
                              [value]="'internal'">
              {{'event.internal' | translate}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }


  @if (filters.eventTypes) {
    <div class="nav-item bottom-border" aria-label="frequently contacted">
      <div class="filter-title" (click)="showEventType = !showEventType">
        {{'event.eventType' | translate}}
        @if (showEventType) {
          <mat-icon  class="expand-icon">expand_less</mat-icon>
        }
        @if (!showEventType) {
          <mat-icon  class="expand-icon">expand_more</mat-icon>
        }
      </div>
      <mat-selection-list [ngClass]="{'visible': showEventType, 'hidden': !showEventType}">
        @for (gr of filters.eventTypes; track gr.id) {
          <mat-list-option
            matTooltip="{{gr?.name}}"
            (click)="gr.selected = !gr.selected;choose({eventType: gr.id, selected: gr.selected})"
            class="target-list"
            [selected]="gr.selected">
            <span style="width: 10%" [ngStyle]="{'background-color' : gr.color}">&nbsp;&nbsp;&nbsp;</span>&nbsp;{{gr.name}}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  }

  @if (filters.targetGroups) {
    <div class="nav-item bottom-border" aria-label="frequently contacted">
      <div class="filter-title" (click)="showTargetGroup = !showTargetGroup">
        {{'event.target_group' | translate}}
        @if (showTargetGroup) {
          <mat-icon  class="expand-icon">expand_less</mat-icon>
        }
        @if (!showTargetGroup) {
          <mat-icon  class="expand-icon">expand_more</mat-icon>
        }
      </div>
      <mat-selection-list [ngClass]="{'visible': showTargetGroup, 'hidden': !showTargetGroup}" (selectionChange)="chooseTG($event)">
        @for (gr of filters.targetGroups; track gr.id) {
          <mat-list-option
            matTooltip="{{(('0' + gr?.targetNumber).slice(-2)) + ' - ' +gr?.ageMask}}"
            (click)="gr.selected = !gr.selected" [value]="gr.id"
            class="target-list"
            [selected]="gr.selected">
            {{(('0' + gr?.targetNumber).slice(-2)) + ' - ' +gr?.ageMask}}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  }

  @if (filters.mileStoneEvent) {
    <div class="nav-item bottom-border pl-16 alone" aria-label="frequently contacted">
      <div class="title"
      matTooltip="{{'event.mile_stone_event' | translate}}">{{'event.mile_stone_event' | translate}}</div>
      <mat-checkbox [checked]="mileStoneEventModel"
        (change)="choose({mileStoneEvent: true, selected: $event.checked})"
        [labelPosition]="'before'">
      </mat-checkbox>
    </div>
  }

  @if (filters.migrate) {
    <div class="nav-item bottom-border pl-16 alone" aria-label="frequently contacted">
      <div class="title"
      matTooltip="{{'event.migrate' | translate}}">{{'event.migrate' | translate}}</div>
      <mat-checkbox [checked]="migrateEventModel"
        (change)="choose({migrate: true, selected: $event.checked})"
        [labelPosition]="'before'">
      </mat-checkbox>
    </div>
  }
  @if (filters.myEvents) {
    <div class="nav-item bottom-border pl-16 alone" aria-label="frequently contacted">
      <div class="title"
      matTooltip="{{'event.myEvents' | translate}}">{{'event.myEvents' | translate}}</div>
      <mat-checkbox [checked]="myEventsModel"
        (change)="choose({myEvents: true, selected: $event.checked})"
        [labelPosition]="'before'">
      </mat-checkbox>
    </div>
  }

  @if (filters.marketplaceCategories) {
    <div class="nav-item bottom-border" aria-label="frequently contacted">
      <div class="filter-title" (click)="showMarketplaceCategories = !showMarketplaceCategories">
        {{'marketplaces.marketplace_category' | translate}}
        @if (showMarketplaceCategories) {
          <mat-icon  class="expand-icon">expand_less</mat-icon>
        }
        @if (!showMarketplaceCategories) {
          <mat-icon  class="expand-icon">expand_more</mat-icon>
        }
      </div>
      <mat-selection-list [ngClass]="{'visible': showMarketplaceCategories, 'hidden': !showMarketplaceCategories}"
        (selectionChange)="chooseMarketplaceCategory($event)">
        @for (gr of filters.marketplaceCategories; track gr.id) {
            <mat-list-option matTooltip="{{!gr.total ? gr.name : !gr.notActivated ? gr.name + ' (' + gr.total + ')' :
              gr.name + ' (' + gr.total + ') ' +  gr.notActivated}}"
            (click)="gr.selected = !gr.selected" [value]="gr.id"
            class="marketplace-category-list"
            [selected]="gr.selected">
            {{gr.name}} @if (gr.total) {
            ({{gr.total}})&nbsp;
            @if (gr.notActivated) {
              <div class="red">{{gr.notActivated}}</div>
            }
          }
        </mat-list-option>
        @for (subgr of gr.marketplaceSubcategory; track subgr) {
              <mat-list-option matTooltip="{{!subgr.total ? subgr.name : !subgr.notActivated ? subgr.name + ' (' + subgr.total + ')' :
              subgr.name + ' (' + subgr.total + ') ' +  subgr.notActivated}}"
            (click)="subgr.selected = !subgr.selected" [value]="subgr.id + '_sub'"
            class="marketplace-subcategory-list"
            [selected]="subgr.selected">
            &nbsp;&nbsp;&nbsp;{{subgr.name}} @if (subgr.total) {
            ({{subgr.total}})&nbsp;
            @if (subgr.notActivated) {
              <div class="red">{{subgr.notActivated}}</div>
            }
          }
        </mat-list-option>
      }
    }
  </mat-selection-list>
</div>
}

@if (filters.marketplaceType) {
  <div class="nav-item bottom-border" aria-label="frequently contacted">
    <div class="filter-title">{{'marketplaces.type' | translate}}
      <span class="clean" (click)="choose({marketplaceType: ''}); marketplaceType = ''">{{'clean' | translate}}</span>
    </div>
    <mat-radio-group class="radio-group" [value]="marketplaceType">
      <mat-radio-button class="radio-buttons" (change)="choose({marketplaceType: 'search'})"
        [value]="'search'">
        {{'marketplaces.i_search' | translate}}
      </mat-radio-button>
      <mat-radio-button class="radio-buttons" (change)="choose({marketplaceType: 'offer'})"
        [value]="'offer'">
        {{'marketplaces.i_offer' | translate}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
}

@if (filters.marketplaceStatus) {
  <div class="nav-item bottom-border" aria-label="frequently contacted">
    <div class="filter-title">{{'marketplaces.status' | translate}}
      <span class="clean" (click)="choose({marketplaceStatus: ''}); marketplaceStatus = ''">{{'clean' | translate}}</span>
    </div>
    <mat-radio-group class="radio-group" [(ngModel)]="marketplaceStatus">
      <mat-radio-button class="radio-buttons" (change)="choose({marketplaceStatus: 'activated'})"
        [value]="'activated'">
        {{'marketplaces.activated' | translate}}
      </mat-radio-button>
      <mat-radio-button class="radio-buttons" (change)="choose({marketplaceStatus: 'notActivated'})"
        [value]="'notActivated'">
        {{'marketplaces.notActivated' | translate}}
      </mat-radio-button>
      <mat-radio-button class="radio-buttons" (change)="choose({marketplaceStatus: 'blocked'})"
        [value]="'blocked'">
        {{'marketplaces.blocked' | translate}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
}
</div>
</div>
</div>
